import { Provider } from '@angular/core';
import {
  DictionaryEntry,
  DYNAMIC_CONFIG_TOKEN,
} from 'libs/platform/dynamic-components/src/lib/services/config-fetchers/fetch-config-from-code.service';

import { esprit } from './esprit';

const espritConfigs: DictionaryEntry[] = [
  ['esprit:below-config-strip', [esprit.belowConfigStrip]],
];

export const espritConfigsInjectionTokenProvider: Provider = {
  provide: DYNAMIC_CONFIG_TOKEN,
  useValue: espritConfigs,
  multi: true,
};
